import React, { useEffect, useState } from 'react'
import { getWpWonderKids } from '../../../api/api_wp'
import Loader from '../../Loader/Loader';

function FmWonderKids() {

    const [posts, setPosts] = useState([])
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredPosts, setFilteredPosts] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {

        let isCancelled = false

        async function getWonderKids() {
            setIsLoading(true)
            let allPlayers = []

            allPlayers = await getWpWonderKids(1, 100);

            if (allPlayers?.length === 100) {
                const dataPage2 = await getWpWonderKids(2, 100);
                allPlayers = allPlayers.concat(dataPage2);
            }
            if (!isCancelled) {
                setPosts(allPlayers)
                setFilteredPosts(allPlayers)
            }
            setIsLoading(false)
            
        }
        getWonderKids()

        return () => {
            isCancelled = true;
        }

    }, [])

    useEffect(() => {

        if (searchTerm) {
            const filteredPosts = posts?.filter((post) => post.title.rendered.toLowerCase().includes(searchTerm.toLowerCase()))
            setFilteredPosts(filteredPosts)
        }
        if (searchTerm === "") {
            setFilteredPosts(posts)
        }

    }, [searchTerm])

    return (
        <div>
            <label className={searchTerm ? "text-muted" : "text-white"}>
                <small>Søk vidunderbarn</small>
            </label>
            <input value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="form-control mb-2" placeholder="Søk vidunderbarn" />
            <p>Viser <span className="font-weight-bold">{filteredPosts?.length}</span> vidunderbarn</p>

            {isLoading && <Loader />}

            {!isLoading && (
                <div className="table-responsive">
                <table className="table table-bordered table-hover table-striped">
                    <thead>
                        <tr>
                            <th>Navn</th>
                            <th>Klubb</th>
                            <th>Posisjon</th>
                            <th>Potensiale</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredPosts?.map((post, index) => {
                            return (
                                <tr key={index}>
                                    <td>{post?.title?.rendered}</td>
                                    <td>{post?.acf?.navaerende_klubb}</td>
                                    <td>{post?.acf?.posisjon}</td>
                                    <td>{post?.acf?.potensielt_niva}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            )}
            
        </div>
    )
}
export default FmWonderKids